<template>
  <CModal
    :title="title"
    :color="color"
    size="lg"
    :show.sync="showModal"
  >
    <CForm id="award_form" method="POST" enctype="multipart/form-data">
      <AwardBuyModalWalletRangeContent
        v-if="isWalletRange"
        :item="item"
        :available-points="availablePoints"
        :selected-points="form.selected_points"
        @update:selected-points="onSelectedWalletPoints"
      />
      <AwardBuyModalDefaultContent
        v-else
        :item="item"
      />
    </CForm>

    <template #footer>
      <CButton @click="closeModal" color="secondary">Cancelar</CButton>
      <CButton @click="boughtProduct" :color="color" :disabled="!canConfirm">Confirmar</CButton>
    </template>
  </CModal>
</template>

<script>
import AwardBuyModalDefaultContent from './AwardBuyModalDefaultContent.vue'
import AwardBuyModalWalletRangeContent from './AwardBuyModalWalletRangeContent.vue'

export default {
  name: 'AwardBuyModal',
  components: {
    AwardBuyModalDefaultContent,
    AwardBuyModalWalletRangeContent
  },
  data () {
    return {
      showModal: false,
      title: 'Canjear Puntos',
      color: 'info',
      item: {},
      availablePoints: 0,
      form: this.getEmptyForm(),
      submitted: false
    }
  },
  computed: {
    isWalletRange () {
      return this.item
        && this.item.type === 'wallet_points'
        && this.item.wallet_mode === 'range'
    },
    canConfirm () {
      if (!this.form.id || !this.form.type) {
        return false
      }

      if (!this.isWalletRange) {
        return true
      }

      const selected = Number(this.form.selected_points || 0)
      return selected > 0 && selected <= Number(this.availablePoints || 0)
    }
  },
  methods: {
    storeModal (product, availablePoints = 0) {
      this.showModal = true
      this.title = 'Canjear Puntos'
      this.submitted = false

      this.item = product || {}
      this.availablePoints = Number(availablePoints || 0)

      const selectedPoints = this.resolveInitialSelectedPoints(product)

      this.form = {
        id: product.id,
        type: product.type,
        price: selectedPoints,
        selected_points: selectedPoints
      }
    },
    resolveInitialSelectedPoints (product) {
      if (!product || !(product.type === 'wallet_points' && product.wallet_mode === 'range')) {
        return Number(product && product.price ? product.price : 0)
      }

      const start = Math.max(0, Number(product.range_start || 0))
      const end = Math.max(0, Number(product.range_end || 0))
      const step = Math.max(1, Number(product.range_step || 1))
      const limitByPoints = Math.max(0, Number(this.availablePoints || 0))
      const rawMax = Math.min(end, limitByPoints)

      if (rawMax < start) {
        return 0
      }

      const steps = Math.floor((rawMax - start) / step)
      const maxSelectable = start + (steps * step)

      return start <= maxSelectable ? start : 0
    },
    onSelectedWalletPoints (points) {
      const selected = Number(points || 0)
      this.form.selected_points = selected
      this.form.price = selected
    },
    boughtProduct () {
      if (!this.canConfirm) {
        return
      }

      this.submitted = true
      this.$emit('bought', this.form)
      this.closeModal()
    },
    closeModal () {
      this.showModal = false
      this.item = {}
      this.availablePoints = 0
      this.form = this.getEmptyForm()
      this.submitted = false
    },
    getEmptyForm () {
      return {
        id: 0,
        type: 'event_points',
        price: 0,
        selected_points: 0
      }
    }
  }
}
</script>